// ✅ CREATED BY SOHAIL: Version tracker - stores current version for error-based reload detection
// This component doesn't proactively reload - it just tracks version
// Actual reload happens in api.ts interceptor when errors occur

import { useEffect } from "react";

const VERSION_KEY = "philanthrify_version";

export default function AutoReloadChecker() {
  useEffect(() => {
    // Store current version on app load
    const storeVersion = async () => {
      try {
        const response = await fetch(window.location.origin, {
          method: "HEAD",
          cache: "no-cache",
        });
        const serverVersion = response.headers.get("X-App-Version");
        if (serverVersion) {
          localStorage.setItem(VERSION_KEY, serverVersion);
        }
      } catch (error) {
        // Silently fail
        console.debug("[VERSION TRACKER] Failed to store version:", error);
      }
    };

    // Store version after app loads
    setTimeout(storeVersion, 2000);
  }, []);

  return null; // No UI
}

